<template>
    <b-modal
        id="modal-finalizacao-acolhimento"
        title="Finalização do acolhimento"
        size="lg"
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        @hidden="limpar"
    >
        <div class="alert alert-info">
            Você está finalizando este acolhimento.

            O motivo da finalização é obrigatório e a observação é opcional.
        </div>

        <div class="row">
            <div
                v-if="loading"
                class="col-12 text-center py-4"
            >
                <i class="fas fa-spinner fa-spin mr-2" />

                Carregando motivos de finalização...
            </div>

            <form-select
                v-else
                v-model="motivoFinalizacaoId"
                label="Motivo da finalização"
                :itens="opcoesMotivos"
                :required="true"
                grid="12"
            />

            <div
                v-if="erroMotivo"
                class="col-12"
            >
                <div class="alert alert-danger py-2">
                    {{ erroMotivo }}
                </div>
            </div>

            <form-textarea-editor
                v-model="observacao"
                label="Observação"
            />
        </div>

        <div class="d-flex justify-content-end mt-3">
            <button
                type="button"
                class="btn btn-secondary"
                @click="cancelar"
            >
                Cancelar
            </button>

            <button
                type="button"
                class="btn btn-success ml-2"
                :disabled="
                    loading ||
                    motivos.length === 0
                "
                @click="confirmar"
            >
                <i
                    v-if="loading"
                    class="fas fa-spinner fa-spin"
                />

                <i
                    v-else
                    class="mdi mdi-check"
                />

                Confirmar finalização
            </button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "ModalFinalizacaoAcolhimento",

    props: {
        motivos: {
            type: Array,
            default: () => [],
        },

        loading: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            motivoFinalizacaoId: null,
            observacao: "",
            erroMotivo: "",
        };
    },

    computed: {
        opcoesMotivos() {
            return [
                {
                    id: null,
                    value: "Selecione",
                },
                ...this.motivos,
            ];
        },
    },

    watch: {
        motivoFinalizacaoId(novoValor) {
            const motivoId = Number(
                novoValor?.id ?? novoValor
            );

            if (motivoId && !Number.isNaN(motivoId)) {
                this.erroMotivo = "";
            }
        },
    },

    methods: {
        confirmar() {
            const motivoId = Number(
                this.motivoFinalizacaoId?.id ??
                this.motivoFinalizacaoId
            );

            if (
                !motivoId ||
                Number.isNaN(motivoId)
            ) {
                this.erroMotivo =
                    "Selecione o motivo da finalização.";

                return;
            }

            this.erroMotivo = "";

            this.$emit("confirmar", {
                motivo_finalizacao_id:
                    motivoId,

                observacao:
                    String(
                        this.observacao || ""
                    ).trim() || null,
            });

            this.$bvModal.hide(
                "modal-finalizacao-acolhimento"
            );
        },

        cancelar() {
            this.$emit("cancelar");

            this.$bvModal.hide(
                "modal-finalizacao-acolhimento"
            );
        },

        limpar() {
            this.motivoFinalizacaoId = null;
            this.observacao = "";
            this.erroMotivo = "";
        },
    },
};
</script>